import React from "react"
import SEO from "../components/seo"
import { graphql } from "gatsby"
import Image from "gatsby-image"

import Layout from "../components/layout"
import Instrument from "../components/global/Instrument"
import { documentToReactComponents } from "@contentful/rich-text-react-renderer"

const tourTemplate = ({ data }) => {
  const instrument = data.instrument
  return (
    <Layout>
      <SEO title={`${instrument.name}unterricht`} keywords={[]} />
      <div className="container mx-auto">
        <div className="lg:flex lg:flex-wrap lg:-mx-2">
          <div className="lg:w-1/2 py-2">
            <Instrument>
              <div
                style={{ backgroundColor: `${instrument.color}` }}
                className="absolute top-0 left-0 bottom-0 right-0 p-2 sm:p-6 md:p-8 bg-primary"
              >
                <div className="white-frame flex flex-col items-center justify-center">
                  <div className="z-40 mt-auto h-full w-64 sm:w-72 md:w-84 relative mb-20">
                    <Image fluid={instrument.images.fluid} />
                  </div>
                  <h3 className="absolute bottom-0 py-2 sm:py-10 md:py-8 lg:py-6 xl:py-8 text-xl lg:text-3xl font-display capitalize">
                    {instrument.name}
                  </h3>
                </div>
              </div>
            </Instrument>
          </div>

          {
            <article class="py-12 px-8 lg:w-1/2 flex items-center justify-center">
              <div className="">
                {documentToReactComponents(
                  instrument.childContentfulInstrumentDescriptionRichTextNode
                    .json
                )}
              </div>
            </article>
          }
        </div>
      </div>
    </Layout>
  )
}

export const query = graphql`
  query($slug: String!) {
    instrument: contentfulInstrument(slug: { eq: $slug }) {
      name
      childContentfulInstrumentDescriptionRichTextNode {
        json
      }
      images {
        fluid {
          ...GatsbyContentfulFluid_tracedSVG
        }
      }
    }
  }
`

export default tourTemplate
